// extracted by mini-css-extract-plugin
export default {"circle":"circle_v_7S"};